function normalizeSearchValue(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

function normalizeCompactSearchValue(value) {
  return normalizeSearchValue(value).replace(/[^a-z0-9]/g, "");
}

export function matchesRecordNumberSearch(record, query, extraFields = []) {
  const rawQuery = normalizeSearchValue(query);
  if (!rawQuery) return true;
  const compactQuery = normalizeCompactSearchValue(rawQuery);
  const fields = [
    record?.recordNumber,
    record?.orderRecordNumber,
    record?.entityRecordNumber,
    record?.id,
    record?.clientId,
    ...(Array.isArray(extraFields) ? extraFields : []),
  ];
  return fields.some((field) => {
    const rawField = normalizeSearchValue(field);
    if (!rawField) return false;
    if (rawField.includes(rawQuery)) return true;
    const compactField = normalizeCompactSearchValue(rawField);
    return !!compactQuery && !!compactField && compactField.includes(compactQuery);
  });
}

export function getPreferredRecordLabel(record, fallback = "", options = {}) {
  const includeTechnicalId = !!options?.includeTechnicalId;
  return String(
    record?.recordNumber
      || record?.orderRecordNumber
      || record?.entityRecordNumber
      || (includeTechnicalId ? record?.id : "")
      || fallback
      || ""
  ).trim();
}
